import { render, staticRenderFns } from "./carousel.module.vue?vue&type=template&id=618e9024&scoped=true"
import script from "./carousel.module.vue?vue&type=script&lang=js"
export * from "./carousel.module.vue?vue&type=script&lang=js"
import style0 from "./carousel.module.vue?vue&type=style&index=0&id=618e9024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e9024",
  null
  
)

export default component.exports